import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { styled } from '@mui/material/styles';
import DialogMUI from '@mui/material/Dialog';
import { STYLE_OPTIONS } from 'src/constants';

function Dialog({
  children,
  modalSize,
  ...restProps
}) {
  const getDialogStyle = (size) => {
    switch (size) {
      case 'xl':
        return {
          width: '90%',
          maxWidth: '987px',
        };
      case 'sm':
        return {
          width: '500px',
          maxWidth: '600px',
        };
      case 'xs':
        return {
          width: '400px',
          maxWidth: '500px',
        };
      default:
        return {
          width: '706px',
          maxWidth: '800px',
        };
    }
  };
  const CustomDialog = useMemo(() => styled(DialogMUI)((props) => ({
    // eslint-disable-next-line react/prop-types
    [props.theme.breakpoints.up('md')]: {
      '& > .MuiDialog-container > .MuiPaper-root': {
        ...getDialogStyle(modalSize),
        borderRadius: '20px',
        fontFamily: STYLE_OPTIONS.FONT_FAMILY
      }
    }
  })), [modalSize]);

  return (
    <CustomDialog {...restProps}>{children}</CustomDialog>
  );
}

Dialog.propTypes = {
  children: PropTypes.node,
  modalSize: PropTypes.string,
};

Dialog.defaultProps = {
  children: null,
  modalSize: null,
};

export default Dialog;
